var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeProducttour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 208,
    viewBox: "0 0 198 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 198C153.676 198 198 153.676 198 99C198 44.3238 153.676 0 99 0C44.3238 0 0 44.3238 0 99C0 153.676 44.3238 198 99 198Z",
    fill: "#191925"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_23225_51373)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23225_51373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 198,
    height: 198
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99 198C153.676 198 198 153.676 198 99C198 44.3238 153.676 0 99 0C44.3238 0 0 44.3238 0 99C0 153.676 44.3238 198 99 198Z",
    fill: "url(#paint0_linear_23225_51373)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23225_51373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.76 56.76H42.2396C38.5946 56.76 35.6396 59.7149 35.6396 63.36V201.96C35.6396 205.605 38.5946 208.56 42.2396 208.56H155.76C159.405 208.56 162.36 205.605 162.36 201.96V63.36C162.36 59.7149 159.405 56.76 155.76 56.76Z",
    fill: "#222231"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1198 69.96H52.7998C50.6128 69.96 48.8398 71.7329 48.8398 73.92C48.8398 76.107 50.6128 77.88 52.7998 77.88H87.1198C89.3069 77.88 91.0798 76.107 91.0798 73.92C91.0798 71.7329 89.3069 69.96 87.1198 69.96Z",
    fill: "#9796F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1198 125.4H52.7998C50.6128 125.4 48.8398 127.173 48.8398 129.36C48.8398 131.547 50.6128 133.32 52.7998 133.32H87.1198C89.3069 133.32 91.0798 131.547 91.0798 129.36C91.0798 127.173 89.3069 125.4 87.1198 125.4Z",
    fill: "#9796F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.561 89.76H55.4411C52.5251 89.76 50.1611 92.1239 50.1611 95.04V108.24C50.1611 111.156 52.5251 113.52 55.4411 113.52H142.561C145.477 113.52 147.841 111.156 147.841 108.24V95.04C147.841 92.1239 145.477 89.76 142.561 89.76Z",
    fill: "#191925",
    stroke: "#A7F4FF",
    strokeWidth: 2.64
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.56 143.88H55.4398C51.7948 143.88 48.8398 146.835 48.8398 150.48V161.04C48.8398 164.685 51.7948 167.64 55.4398 167.64H142.56C146.205 167.64 149.16 164.685 149.16 161.04V150.48C149.16 146.835 146.205 143.88 142.56 143.88Z",
    fill: "#191925"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9607 42.2401C72.8767 42.2401 75.2407 39.8761 75.2407 36.9601C75.2407 34.044 72.8767 31.6801 69.9607 31.6801C67.0446 31.6801 64.6807 34.044 64.6807 36.9601C64.6807 39.8761 67.0446 42.2401 69.9607 42.2401Z",
    fill: "#191925"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0007 42.2401C101.917 42.2401 104.281 39.8761 104.281 36.9601C104.281 34.044 101.917 31.6801 99.0007 31.6801C96.0846 31.6801 93.7207 34.044 93.7207 36.9601C93.7207 39.8761 96.0846 42.2401 99.0007 42.2401Z",
    fill: "#A7F4FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.041 42.2401C130.957 42.2401 133.321 39.8761 133.321 36.9601C133.321 34.044 130.957 31.6801 128.041 31.6801C125.125 31.6801 122.761 34.044 122.761 36.9601C122.761 39.8761 125.125 42.2401 128.041 42.2401Z",
    fill: "#191925"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.52 116.16C117.165 116.16 120.12 113.205 120.12 109.56C120.12 105.915 117.165 102.96 113.52 102.96C109.875 102.96 106.92 105.915 106.92 109.56C106.92 113.205 109.875 116.16 113.52 116.16Z",
    fill: "#2B2B3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.677 137.768C117.621 137.768 116.635 137.768 115.737 137.712C114.632 137.637 113.568 137.259 112.664 136.618C111.759 135.978 111.049 135.101 110.61 134.083L105.041 123.077C104.633 122.601 104.429 121.983 104.474 121.358C104.519 120.733 104.809 120.151 105.282 119.738C105.669 119.427 106.151 119.26 106.648 119.265C107.013 119.275 107.372 119.365 107.7 119.528C108.027 119.69 108.315 119.922 108.545 120.207L111.074 123.659L111.112 123.704V110.59C111.112 109.939 111.37 109.315 111.831 108.855C112.291 108.395 112.915 108.136 113.565 108.136C114.216 108.136 114.84 108.395 115.3 108.855C115.76 109.315 116.018 109.939 116.018 110.59V119.17C115.99 118.854 116.028 118.536 116.129 118.235C116.23 117.935 116.393 117.659 116.607 117.425C116.821 117.191 117.081 117.004 117.371 116.876C117.661 116.748 117.974 116.682 118.291 116.682C118.608 116.682 118.922 116.748 119.212 116.876C119.502 117.004 119.762 117.191 119.976 117.425C120.19 117.659 120.353 117.935 120.454 118.235C120.555 118.536 120.593 118.854 120.565 119.17V120.958C120.536 120.642 120.574 120.324 120.675 120.024C120.776 119.723 120.939 119.447 121.153 119.213C121.367 118.979 121.627 118.793 121.917 118.665C122.207 118.537 122.521 118.471 122.838 118.471C123.155 118.471 123.468 118.537 123.758 118.665C124.048 118.793 124.309 118.979 124.522 119.213C124.736 119.447 124.899 119.723 125 120.024C125.102 120.324 125.139 120.642 125.111 120.958V122.336C125.082 122.021 125.12 121.702 125.221 121.402C125.322 121.102 125.485 120.826 125.699 120.592C125.913 120.358 126.173 120.171 126.463 120.043C126.753 119.915 127.067 119.849 127.384 119.849C127.701 119.849 128.014 119.915 128.304 120.043C128.594 120.171 128.855 120.358 129.068 120.592C129.282 120.826 129.445 121.102 129.546 121.402C129.648 121.702 129.685 122.021 129.657 122.336V130.701C129.612 133.274 128.449 137.611 124.358 137.611C124.061 137.625 121.545 137.77 118.682 137.77L118.677 137.768Z",
    fill: "#A7F4FF",
    stroke: "#191925",
    strokeWidth: 1.32
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_23225_51373",
    x: 27.6396,
    y: 50.76,
    width: 142.72,
    height: 157.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_23225_51373"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23225_51373"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_23225_51373",
    result: "effect2_dropShadow_23225_51373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_23225_51373",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23225_51373",
    x1: 99,
    y1: 0,
    x2: 99,
    y2: 198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeProducttour);
export default __webpack_public_path__ + "static/media/welcome_producttour.bf2db48ea7009a82a7d600451ae71c30.svg";
export { ForwardRef as ReactComponent };